import styled from 'styled-components';
import { mediaBreakpointUp, mediaBreakpointDown } from 'styles/grid';
import { spacingBox } from 'styles/parcelSharedStyles';

export const MainContentWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  min-height: 0;
  min-height: initial;

  ${mediaBreakpointUp.md} {
    min-height: 0;
  }
`;

export const ParcelDetailsBox = styled.div`
  background-color: ${({ theme }) => theme.configs.mainBox.bgColor};

  ${mediaBreakpointUp.md} {
    background-image: url(${({ theme }) =>
      theme.configs.parcelDetailsBox.bgImage});
    background-position: center;
    background-repeat: no-repeat;
    background-size: ${({ theme }) =>
      theme.configs.parcelDetailsBox.bgImageSize};
  }

  ${({ theme }) =>
    theme.configs.parcelDetailsBox.shouldShowBorder &&
    `border: 1px solid ${theme.configs.mainBox.bgColor}`};

  height: 100%;
  ${({ theme }) =>
    !theme.configs.parcelDetailsBox.shouldHideOutsideBorder && spacingBox}
`;

export const ParcelDetailsContainer = styled.div`
  flex: 0 0 100%;
  margin-bottom: 8px;
  height: auto;

  ${mediaBreakpointUp.md} {
    height: 500px;
    flex: 1;
    margin-bottom: 0;
    margin-right: 16px;
  }
`;

export const TrackingDetailsContainer = styled.div`
  flex: 0 0 100%;
  ${mediaBreakpointUp.md} {
    flex: 2;
  }
  height: 500px;

  position: relative;
  border: solid 1px;
  background-color: ${({ theme }) => theme.configs.tertiaryBox.bgColor};
  color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
  border-color: ${({ theme }) => theme.configs.trackingDetailsBox.borderColor};

  ${mediaBreakpointDown.sm} {
    height: auto;
  }
`;

export const AdditionalContentContainer = styled.div`
  margin-top: 16px;
`;
